import React from 'react';
const ClaimSelect = () => null;
export default ClaimSelect;